:host {
    display: block;
    padding-top: 80px;
    background-color: $color-grey-01-dark;
    color: $color-grey-05-light;
    margin-top: 1px;
}

:host(:not([no-margin])) {
    margin-top: var(--footer-margin-top, 100px);

    @include mq-2 {
        margin-top: var(--footer-margin-top, 80px);
    }

    @include mq-1 {
        margin-top: var(--footer-margin-top, 60px);
    }
}

.grid {
    @include grid;
}

slot[name='column1'] {
    display: block;
    grid-column: 2 / span 3;
}

slot[name='column2'] {
    display: block;
    grid-column: 5 / span 3;
}

slot[name='column3'] {
    display: block;
    grid-column: 8 / span 3;
}

slot[name='column4'] {
    display: block;
    grid-column: 11 / span 3;
}

.footer-bottom {
    @include typo-ws-paragraph-s;

    margin-top: 40px;
    grid-column: 2 / -2;
    border-top: 1px solid $color-grey-03;
    display: flex;
    align-items: center;
    padding: 20px 0 40px;
}

slot[name='logo'] {
    display: none;
}

:host([logo]) {
    .footer-bottom {
        padding: 40px 0 44px;
        align-items: flex-end;
    }

    slot[name='logo'] {
        display: block;
        order: 1;
        margin-right: 40px;
    }

    ::slotted(sew-ws-footer-linklist-legal) {
        order: 2;
    }

    ::slotted(sew-ws-footer-linklist-social) {
        order: 4;
    }

    .copyright {
        order: 3;
        margin-left: 20px;
    }

    ::slotted(:last-child) {
        margin-left: auto;
    }
}

:host(.legal-only) {
    padding-top: 0;

    .footer-bottom {
        margin-top: 0;
        border-top: 0;
    }
}

@include mq-3-min {
    .copyright {
        margin-left: 30px;
    }

    ::slotted(sew-ws-footer-linklist-social) {
        margin-left: auto;
    }
}

@include mq-2 {
    :host {
        padding-top: 60px;
    }

    slot[name='column1'] {
        grid-column: 2 / span 6;
    }

    slot[name='column2'],
    slot[name='column3'] {
        display: none;
    }

    slot[name='column4'] {
        grid-column: 8 / span 6;
    }

    .footer-bottom {
        flex-direction: column;
        align-items: stretch;
        gap: 30px;

        ::slotted(sew-ws-footer-linklist-social) {
            order: 1;
        }

        ::slotted(sew-ws-footer-linklist-legal) {
            order: 2;
        }

        .copyright {
            order: 3;
        }
    }

    :host([logo]) {
        .footer-bottom {
            display: grid;
            align-items: flex-end;
            padding: 32px 0 40px;
            gap: 0;
            row-gap: 32px;

            slot[name='logo'],
            ::slotted(sew-ws-footer-linklist-social) {
                grid-row: 1;
            }

            ::slotted(sew-ws-footer-linklist-legal),
            .copyright {
                grid-row: 2;
            }

            ::slotted(sew-ws-footer-linklist-legal) {
                grid-column: 1;
                margin: 0;
            }

            ::slotted(sew-ws-footer-linklist-social) {
                grid-column: 2;
            }

            .copyright {
                grid-column: 2;
            }

            .copyright,
            ::slotted(sew-ws-footer-linklist-social) {
                justify-self: flex-end;
            }
        }
    }
}

@include mq-1 {
    :host {
        padding-top: 40px;
    }

    slot[name='column1'],
    slot[name='column2'],
    slot[name='column3'] {
        display: none;
    }

    slot[name='column4'] {
        grid-column: 2 / span 12;
    }

    :host([logo]) {
        .footer-bottom {
            display: grid;
            align-items: flex-start;
            padding: 32px 0 40px;
            gap: 0;

            slot[name='logo'] {
                grid-row: 1;
                grid-column: 1;
            }

            ::slotted(sew-ws-footer-linklist-social) {
                grid-row: 2;
                grid-column: 1;
                justify-self: flex-start;
                margin: 0;
                margin-top: 32px;
            }

            ::slotted(sew-ws-footer-linklist-legal) {
                grid-row: 3;
                grid-column: 1;
                margin-top: 32px;
            }

            .copyright {
                grid-row: 4;
                grid-column: 1;
                justify-self: flex-start;
                margin: 0;
                margin-top: 32px;
            }
        }
    }
}
